module.exports = __webpack_public_path__ + "static/Chantal-0f278fc9f314aad577b251858af1c8e1.png";